export default "__VITE_ASSET__e6859099__"